import { StripeMethod } from '@/types';

export const PAYMENTS_ROOT_URL = process.env.REACT_APP_PAYMENTS_ROOT_URL as string;
export const GTM_ENABLED = process.env.REACT_APP_GTM_ENABLED as unknown as boolean;
export const TAG_MANAGER_ID = process.env.REACT_APP_TAG_MANAGER_ID as string;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY as string;
export const ENV = process.env.REACT_APP_ENV as string;
export const DEFAULT_LANG = process.env.REACT_APP_DEFAULT_LANG as string;
export const STORAGE_PREFIX = process.env.REACT_APP_STORAGE_PREFIX as string;
export const APP_HOME_URL = process.env.REACT_APP_HOME_URL as string;
export const APP_404_URL = process.env.REACT_APP_404_URL as string;
export const APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL as string;
export const APP_BACKEND_LOGOUT_URL = process.env.REACT_APP_BACKEND_LOGOUT_URL as string;
export const APP_SIGNUP_URL = process.env.REACT_APP_SIGNUP_URL as string;
export const SIGNUP_BACKEND_URL = process.env.REACT_APP_SIGNUP_BACKEND_URL as string;
export const DEFAULT_THEME = process.env.REACT_APP_DEFAULT_THEME as string;
export const LANG_COOKIE_NAME = process.env.REACT_APP_LANG_COOKIE_NAME as string;
export const THEME_ASSETS_URL = process.env.REACT_APP_THEME_ASSETS_URL as string;
export const ADMIN_EMAIL_ADDRESS = process.env.REACT_APP_ADMIN_EMAIL_ADDRESS as string;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL as string;
export const AUTH_HOST = process.env.REACT_APP_AUTH_HOST as string;
export const HOME = process.env.REACT_APP_HOME as string;
export const PAYMENTS_BACKEND_URL = process.env.REACT_APP_PAYMENTS_BACKEND_URL as string;
export const PAYMENTS_FRONTEND_URL = process.env.REACT_APP_PAYMENTS_FRONTEND_URL as string;
export const NOTIFICATION_NEW_FREE_REMINDER_ID = 'NewFreeReminder' as string;
export const NOTIFICATION_NO_BILLING_REMINDER_ID = 'NoBillingReminder' as string;
export const NOTIFICATION_CHECKOUT_REMINDER_ID = 'CheckoutReminder' as string;
export const NOTIFICATION_DEFAULT_AUTOCLOSE_TIME_IN_MS = 2000;
export const RUN_GTM_CALLBACKS_IN_MS = 4000;
export const MDIRECTOR_SUPPORT_PHONE = process.env.REACT_APP_MDIRECTOR_SUPPORT_PHONE;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY as string;
export const REGISTER_DOMAIN = process.env.REACT_APP_REGISTER_DOMAIN as string;
export const DEFAULT_STRIPE_METHOD = 'checkout' as StripeMethod;
export const DEFAULT_MY_RATE_REFRESH_TIME_IN_SEG = 5;
export const DEFAULT_MANUAL_VALIDATION_NEEDED = true as boolean;
export const SHOW_ANNUAL_PAYMENTS = process.env
  .REACT_APP_SHOW_ANNUAL_PAYMENTS as unknown as boolean;
export const PHONE_VALIDATION_ACTIVATED = process.env
  .REACT_APP_PHONE_VALIDATION_ACTIVATED as unknown as boolean;
export const APP_APPSUMO_URL = 'https://appsumo.com/account/products/' as string;
export const APP_PMP_URL = 'https://pmp.antevenio.com/assets/consenter.js' as string;
export const PHONE_USER_CONSENT_CHECKBOX = (process.env.REACT_APP_PHONE_USER_CONSENT_CHECKBOX ===
  'true') as boolean;
export const SHOW_TOUR_BUTTON_ON_PRODUCTS = (process.env.REACT_APP_SHOW_TOUR_BUTTON_ON_PRODUCTS ===
  'true') as boolean;
export const TOUR_BUTTON_REQUEST_URL = process.env.REACT_APP_TOUR_BUTTON_REQUEST_URL as string;
// export const COUPONS_ENABLED = process.env.REACT_APP_COUPONS_ENABLED as unknown as boolean;
export const COUPONS_ENABLED = true as boolean;
export const RECAPTCHA_TURNSTILE_SITE_KEY = process.env
  .REACT_APP_RECAPTCHA_TURNSTILE_SITE_KEY as string;
export const RECAPTCHA_NEEDED = true as boolean;
export const PATH_UPDATE_PAYMENT_METHOD = '/account/update-payment-method' as string;
export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN as string;
export const COOKIE_FORCE_IS_EUROPE = 'forceIsEurope' as string;
export const APP_EMBLUE_MD_HOME_URL = process.env.REACT_APP_EMBLUE_MD_HOME_URL as string;
